<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" location="left" temporary>
      <Navigation></Navigation>
    </v-navigation-drawer>
    <v-app-bar app color="primary" scroll-behavior="hide">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-img
        class="mr-2"
        :src="'/img/logo.svg'"
        width="32"
        height="32"
        max-width="32"
        max-height="32"
        contain
      />
      <v-toolbar-title v-if="$vuetify.display.xs"> АКФД</v-toolbar-title>
      <v-toolbar-title class="text-uppercase" v-else>
        Алтайская Краевая Федерация Джиу-Джитсу</v-toolbar-title
      >

      <v-btn
        href="https://instagram.com/altai_jiu_jitsu_federation"
        target="_blank"
        icon
      >
        <v-icon>mdi-instagram</v-icon>
      </v-btn>
      <v-btn href="https://vk.com/altayjiujitsu" target="_blank" icon
        ><v-icon>mdi-vk</v-icon>
      </v-btn>
      <v-btn href="https://ok.ru/altjiujitsu" target="_blank" icon
        ><v-icon>mdi-odnoklassniki</v-icon>
      </v-btn>
      <v-btn href="mailto:altai.jiujitsu@gmail.com" icon
        ><v-icon>mdi-gmail</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main style="background-color: #fafafa">
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref } from 'vue'
import Navigation from './components/Navigation'
import { setTitle } from '@/utils/setTitle'

const drawer = ref(false)

setTitle(null)
</script>

<style>
.v-toolbar__content .v-toolbar-title {
  flex: 1 1 0 !important;
  min-width: 0;
}
</style>
